/**
 * Ported VERBATIM from `apr_template/src/services/reportsApi.ts`.
 * Only import paths change. See ../compat/ for the shims.
 */
import api from './aprAxios';

export interface ReportArtifact {
  id: string;
  scope: 'run' | 'portfolio';
  run_id: string | null;
  title: string | null;
  docx_key: string | null; docx_size: number | null;
  pptx_key: string | null; pptx_size: number | null;
  app_count: number | null;
  savings_mid: number | null;
  fingerprint: string | null;
  generated_by: string | null;
  generated_by_name: string | null;
  generated_at: string;
  is_current: boolean;
  // joined on the history endpoint:
  run_name?: string | null;
  client_name?: string | null;
}

export interface CurrentReport { artifact: ReportArtifact | null; stale: boolean; }

export async function listReports(): Promise<ReportArtifact[]> {
  const res = await api.get('/reports');
  return res.data;
}

export async function getPortfolioCurrent(): Promise<CurrentReport> {
  const res = await api.get('/reports/portfolio/current');
  return res.data;
}

export async function getRunCurrent(runId: string): Promise<CurrentReport> {
  const res = await api.get(`/reports/run/${runId}/current`);
  return res.data;
}

export async function generatePortfolioReport(): Promise<ReportArtifact> {
  const res = await api.post('/reports/portfolio/generate');
  return res.data;
}

export async function generateRunReport(runId: string): Promise<ReportArtifact> {
  const res = await api.post(`/reports/run/${runId}/generate`);
  return res.data;
}

function filenameFromResponse(headers: any, fallback: string): string {
  const disposition: string = headers['content-disposition'] || '';
  const match = disposition.match(/filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/);
  return match ? (match[1] ?? '').replace(/['"]/g, '') : fallback;
}

// Download a stored report blob and trigger a browser save.
export async function downloadReport(id: string, fmt: 'docx' | 'pptx'): Promise<void> {
  const res = await api.get(`/reports/${id}/download.${fmt}`, { responseType: 'blob' });
  const filename = filenameFromResponse(res.headers, `report.${fmt}`);
  const url = URL.createObjectURL(res.data as Blob);
  const a = document.createElement('a');
  a.href = url; a.download = filename;
  document.body.appendChild(a); a.click();
  setTimeout(() => { document.body.removeChild(a); URL.revokeObjectURL(url); }, 1000);
}
